import { isArrayLike } from 'mobx';

import { ILocalization } from 'bernie-l10n';
import { SerializedData } from 'bernie-core';

import { InfositeQueryAdapter } from 'stores/adapters/infosite-query-adapter';
import { SearchQueryAdapter } from 'stores/adapters/search-query-adapter';

import { RoomModel } from './room-model';

export const untrackedQueryParams = [
  '0',
  '1',
  '2',
  'authSuccessMsg',
  'hotelId',
  'lang',
  'prefix',
  'pwaDialog',
  'pwaDialogNested',
  'pwaOverlay',
  'rfrr',
  'scrollPosition',
  'splat',
  'top_cur',
  'top_dp',
  'trv_curr',
  'trv_dp',
  'exp_dp',
  'exp_tx',
  'trv_bp'
];

export const singleUseQueryParams = ['rfrr', 'top_dp', 'top_cur', 'trv_dp', 'trv_curr', 'authSuccessMsg', 'exp_dp', 'exp_tx', 'trv_bp'];

export const getSearchImpactingKeys = () => [
  'startDate',
  'endDate',
  'regionId',
  'selected',
  'latLong',
  'destination',
  'rooms',
  'sort',
  'hotelName',
  'price',
  'star',
  'lodging',
  'amenities',
  'travelerType',
  'poi', // Exp 28074: LS_Top_Attractions_Filter_by_Popularity
  'useRewards', // Exp 29018 PWA_SwP_Toggle_with_more_than_1_in_points
  'guestRating',
  'accessibility',
  'paymentType',
  'bedroomFilter',
  'deals', //Deals Filter
  'propertyStyle',
  'misId',
  'rewards'
];

export const getMultiItemMutationImpactingKeys = () => [
  'startDate',
  'endDate',
  'destination',
  'rooms',
  'multiItemCarPickUpTime',
  'multiItemCarDropOffTime'
];

const getToday = (): string => new Date().toISOString().split('T')[0];

const getTomorrow = (): string => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  return tomorrow.toISOString().split('T')[0];
};

const parseInfositeValues = (query: any, l10n: ILocalization, localDateFormat: string): SerializedData => {
  const iqaParsedInQuery = InfositeQueryAdapter.parseIn(query);
  const { adults, children, endDate, startDate } = SearchQueryAdapter.parseOut(iqaParsedInQuery);

  return {
    ...iqaParsedInQuery,
    adults,
    children,
    endDate: sanitizeDateToISO(endDate, l10n, localDateFormat),
    rooms: setDefaultRoomsIfNecessary(iqaParsedInQuery.rooms),
    startDate: sanitizeDateToISO(startDate, l10n, localDateFormat)
  };
};

const sanitizeDateToISO = (date: string, l10n: ILocalization, localDateFormat: string): string => {
  if (date) {
    let dateObj: Date = l10n.parseLocalDateString(date, { raw: localDateFormat }) as Date;

    if (!dateObj) {
      dateObj = l10n.parseLocalDateString(date, { raw: 'yyyy-MM-dd' }) as Date;
    }

    const isoDateString = l10n.formatDate(dateObj, { raw: 'yyyy-MM-dd' });

    if (isoDateString) {
      return isoDateString;
    }
  }

  return '';
};

const localizeDateFromISO = (date: string, l10n: ILocalization, localDateFormat: string): string => {
  if (date) {
    const dateObj: Date = l10n.parseLocalDateString(date, { raw: 'yyyy-MM-dd' }) as Date;
    const localDate = l10n.formatDate(dateObj, { raw: localDateFormat });

    if (localDate) {
      return localDate;
    }
  }

  return '';
};

const setDefaultRoomsIfNecessary = (rooms?: RoomModel[]) => {
  if (!rooms || !isArrayLike(rooms) || rooms.length === 0) {
    return [{ adults: 2, children: [] }];
  }

  return rooms;
};

export const SearchCriteriaUtils = {
  getToday,
  getTomorrow,
  localizeDateFromISO,
  parseInfositeValues,
  sanitizeDateToISO
};
